import $ from 'jquery';

export default function() {
  const checkbox = $("[data-toggle='general-event-toggle']");
  const target   = $("[data-target='tournament-select']");

  if (checkbox.length === 0 || target.length === 0) return;

  const sync = () => {
    const disabled = checkbox.is(':checked');
    target.prop('disabled', disabled);
    target.each((_, el) => {
      if (!el.tomselect) return;
      disabled ? el.tomselect.disable() : el.tomselect.enable();
    });
  };

  checkbox.on('change', sync);
  sync();
};
